export default __webpack_public_path__ + "static/media/man_twoB.79205478.png";